/* global axios */
import ApiClient from './ApiClient';

class SchedulingPagesAPI extends ApiClient {
  constructor() {
    super('scheduling_pages', { accountScoped: true });
  }

  // Duração padrão da CONTA (regra da agenda) — a lista acima é por dono.
  defaults() {
    return axios.get(`${this.url}/defaults`);
  }

  create(page) {
    return axios.post(this.url, { scheduling_page: page });
  }

  update(id, page) {
    return axios.patch(`${this.url}/${id}`, { scheduling_page: page });
  }
}

export default new SchedulingPagesAPI();
